import { IBranchesQuery } from '@/client/types'
import { api } from '@/client/utils'

export const getBranches = async (locale: string) => {
  const url = `/locations/branches/${locale}`
  const { data } = await api.get<IBranchesQuery>(url)
  return data?.branches
}
